/**
 * Aquatic Color System
 * Data-Driven Refinement with Aquatic Fluidity
 */

export const colors = {
  // Primary Palette
  primary: {
    main: '#5C6BC0',
    dark: '#3949AB',
    light: '#7986CB',
    gradient: 'linear-gradient(135deg, #3949AB 0%, #5C6BC0 100%)',
  },

  // Secondary & Accents
  secondary: {
    main: '#26A69A',
    light: '#4DB6AC',
    dark: '#00897B',
  },

  accent: {
    coral: '#FF6B6B',
    coralLight: '#FF8E8E',
  },

  success: {
    main: '#20E3B2',
    light: '#5FFFCC',
    dark: '#00C896',
  },

  warning: {
    main: '#FFB800',
    light: '#FFD666',
    dark: '#CC9300',
  },

  error: {
    main: '#FF6B6B',
    light: '#FF8E8E',
    dark: '#E74C3C',
  },

  // Neutrals
  neutral: {
    50: '#FAFAFA',
    100: '#F5F5F5',
    200: '#EEEEEE',
    300: '#E0E0E0',
    400: '#BDBDBD',
    500: '#9E9E9E',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
  },

  // Background System
  background: {
    default: '#FAFAFA',
    paper: '#FFFFFF',
    elevated: '#FFFFFF',
    gradient: 'radial-gradient(circle at top right, rgba(92, 107, 192, 0.05), transparent)',
  },

  // Text
  text: {
    primary: '#0F172A',
    secondary: '#475569',
    disabled: '#94A3B8',
    inverse: '#FFFFFF',
  },

  // Data Visualization
  charts: {
    primary: '#5C6BC0',
    secondary: '#26A69A',
    tertiary: '#20E3B2',
    quaternary: '#FF6B6B',
    quinary: '#FFB800',
    colorway: ['#5C6BC0', '#26A69A', '#20E3B2', '#FF6B6B', '#FFB800', '#7986CB'],
  },

  // Special Effects
  glass: {
    background: 'rgba(255, 255, 255, 0.8)',
    border: 'rgba(255, 255, 255, 0.2)',
    blur: '10px',
  },

  overlay: {
    light: 'rgba(255, 255, 255, 0.9)',
    medium: 'rgba(15, 46, 61, 0.5)',
    dark: 'rgba(15, 46, 61, 0.8)',
  },
} as const;

// CSS Variables for dynamic theming
export const cssVariables = `
  :root {
    --color-primary: ${colors.primary.main};
    --color-primary-dark: ${colors.primary.dark};
    --color-primary-light: ${colors.primary.light};
    --color-secondary: ${colors.secondary.main};
    --color-success: ${colors.success.main};
    --color-error: ${colors.error.main};
    --color-warning: ${colors.warning.main};

    --color-text-primary: ${colors.text.primary};
    --color-text-secondary: ${colors.text.secondary};

    --color-bg-default: ${colors.background.default};
    --color-bg-paper: ${colors.background.paper};

    --glass-blur: ${colors.glass.blur};
  }
`;
